import React from 'react';
import {
  FaBolt,
  FaBroom,
  FaChalkboardTeacher,
  FaCheckCircle,
  FaCloud,
  FaCodeBranch,
  FaColumns,
  FaCubes,
  FaDatabase,
  FaDesktop,
  FaDraftingCompass,
  FaHandshake,
  FaLayerGroup,
  FaProjectDiagram,
  FaServer,
  FaTachometerAlt,
  FaUsers,
  FaVial,
} from 'react-icons/fa';
import {
  SiAmazonaws,
  SiAmazondynamodb,
  SiCypress,
  SiDatadog,
  SiDocker,
  SiGithubactions,
  SiGraphql,
  SiJest,
  SiMysql,
  SiNestjs,
  SiNextdotjs,
  SiNodedotjs,
  SiPostgresql,
  SiPrisma,
  SiRabbitmq,
  SiReact,
  SiRedis,
  SiServerless,
  SiTerraform,
  SiTestinglibrary,
  SiTypescript,
  SiWebpack,
} from 'react-icons/si';

export const SKILL_GROUPS = [
  {
    title: 'Back-end e arquitetura',
    icon: <FaServer />,
    skills: [
      { name: 'Node.js', icon: <SiNodedotjs /> },
      { name: 'NestJS', icon: <SiNestjs /> },
      { name: 'TypeScript', icon: <SiTypescript /> },
      { name: 'GraphQL', icon: <SiGraphql /> },
      { name: 'RabbitMQ', icon: <SiRabbitmq /> },
      { name: 'Prisma', icon: <SiPrisma /> },
      { name: 'Microsserviços', icon: <FaProjectDiagram /> },
      { name: 'Arquitetura hexagonal', icon: <FaCubes /> },
      { name: 'Event-driven', icon: <FaBolt /> },
    ],
  },
  {
    title: 'Dados',
    icon: <FaDatabase />,
    skills: [
      { name: 'PostgreSQL', icon: <SiPostgresql /> },
      { name: 'MySQL', icon: <SiMysql /> },
      { name: 'Redis', icon: <SiRedis /> },
      { name: 'DynamoDB', icon: <SiAmazondynamodb /> },
    ],
  },
  {
    title: 'Cloud e DevOps',
    icon: <FaCloud />,
    skills: [
      { name: 'AWS (ECS, Lambda, RDS)', icon: <SiAmazonaws /> },
      { name: 'Serverless', icon: <SiServerless /> },
      { name: 'Terraform', icon: <SiTerraform /> },
      { name: 'Docker', icon: <SiDocker /> },
      { name: 'GitHub Actions', icon: <SiGithubactions /> },
      { name: 'Datadog / New Relic', icon: <SiDatadog /> },
    ],
  },
  {
    title: 'Front-end',
    icon: <FaDesktop />,
    skills: [
      { name: 'React', icon: <SiReact /> },
      { name: 'Next.js', icon: <SiNextdotjs /> },
      { name: 'Module Federation', icon: <SiWebpack /> },
      { name: 'SSR / SSG', icon: <FaServer /> },
      { name: 'Web Vitals', icon: <FaTachometerAlt /> },
    ],
  },
  {
    title: 'Qualidade',
    icon: <FaCheckCircle />,
    skills: [
      { name: 'Jest', icon: <SiJest /> },
      { name: 'Cypress', icon: <SiCypress /> },
      { name: 'Testing Library', icon: <SiTestinglibrary /> },
      { name: 'TDD', icon: <FaVial /> },
      { name: 'Clean Code', icon: <FaBroom /> },
      { name: 'SOLID', icon: <FaLayerGroup /> },
    ],
  },
  {
    title: 'Liderança técnica',
    icon: <FaUsers />,
    skills: [
      { name: 'Mentoria e 1:1s', icon: <FaChalkboardTeacher /> },
      { name: 'Code review', icon: <FaCodeBranch /> },
      { name: 'Padrões de arquitetura', icon: <FaDraftingCompass /> },
      { name: 'Alinhamento com produto', icon: <FaHandshake /> },
      { name: 'Scrum / Kanban', icon: <FaColumns /> },
    ],
  },
];
